import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authLogin, authLogout, authMe, authRegister, getAuthConfig } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [config, setConfig] = useState(null); // { enabled, mode }
  const [user, setUser] = useState(null);       // null while loading, false when unauthenticated
  const [ready, setReady] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const cfg = await getAuthConfig();
      setConfig(cfg);
      if (!cfg.enabled) {
        setUser(false);
        setReady(true);
        return;
      }
      try {
        const me = await authMe();
        setUser(me);
      } catch {
        setUser(false);
      }
    } catch {
      setConfig({ enabled: false });
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const u = await authLogin(email, password);
    setUser(u);
    return u;
  };
  const register = async (email, password, name) => {
    const u = await authRegister(email, password, name);
    setUser(u);
    return u;
  };
  const logout = async () => {
    await authLogout();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ config, user, ready, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
